var _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _rect, _rect2, _rect3, _path15, _rect4, _line, _line2, _rect5, _rect6, _rect7, _path16, _line3, _rect8, _rect9, _rect10, _line4, _line5, _rect11, _rect12, _path17, _path18, _path19, _rect13, _path20, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22, _rect23, _rect24, _rect25, _rect26, _rect27, _rect28, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAttendance2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 175,
    viewBox: "0 0 200 175",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6,
    clipPath: "url(#clip0_785_2586)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M195.355 123.971C201.068 140.67 138.412 161.739 81.3841 162.482C24.356 163.225 -6.58746 136.727 17.0763 116.452C40.7401 96.1774 189.641 107.271 195.355 123.971Z",
    fill: "white",
    fillOpacity: 0.4
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.991 32.2358C48.8018 33.5885 50.6621 34.367 51.6042 34.2648C53.9664 34.0084 55.3158 26.2942 53.9993 23.0189C52.6829 19.7435 43.8015 17.2634 42.4539 23.2518C41.9862 25.3301 42.6608 27.3233 43.8399 29.0293L39.7207 39.5906L47.0335 40.5171L46.991 32.2358Z",
    fill: "#FBC5A9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M55.2915 20.2658C55.0693 21.7748 53.612 22.8459 51.9942 22.7219C51.0367 22.8684 49.8279 22.9118 48.5068 22.8274C48.5687 23.2867 48.5637 23.7989 48.4799 24.3679C48.4059 24.8702 48.2677 25.3955 48.078 25.9225C47.8401 25.5736 47.4905 25.3213 47.1052 25.2725C46.0273 25.1359 45.1559 25.8631 45.0274 26.7361C44.8643 27.844 45.4361 28.7329 46.4337 28.9246C45.2893 30.4237 43.8562 31.4803 42.6032 31.3216C40.2232 31.0201 38.9653 27.8553 39.4323 24.6831C39.4487 24.5716 39.4674 24.4612 39.4883 24.3519C38.6071 24.7625 37.7617 25.3399 36.9101 25.9214L36.9101 25.9214C35.1007 27.1571 33.2638 28.4116 30.9987 28.1246C26.4667 27.5504 25.9146 18.8465 32.2464 19.6486C36.5526 20.1942 38.585 21.0447 40.2837 22.1368C40.7823 21.2413 41.4478 20.5196 42.2005 20.052C42.3868 19.9039 42.6581 19.774 42.9996 19.665C43.2094 19.5906 43.4234 19.5355 43.64 19.5011C44.7961 19.2655 46.4297 19.2029 48.2194 19.3709C48.5535 19.4023 48.8807 19.4405 49.1987 19.4848C49.433 17.9292 50.9807 16.8417 52.6604 17.0545C54.3432 17.2677 55.5212 18.7054 55.2915 20.2658Z",
    fill: "#5B1E13"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.3638 72.8115L50.6289 108.806L55.9274 135.831H61.2456L55.9369 72.8115H39.3638Z",
    fill: "#D4A181"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.3014 72.8115C35.0874 91.5103 34.7774 101.709 34.6015 103.408C34.4256 105.107 33.4268 116.485 26.6211 136.401H32.1524C41.1655 117.295 44.3119 105.917 45.3456 103.408C46.3794 100.899 49.4324 90.7003 53.8898 72.8115H34.3014Z",
    fill: "#D4A181"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.1221 72.8115C42.0523 85.1972 47.1204 104.968 54.3262 132.124H62.1046C62.6791 104.251 60.2351 85.9059 56.0028 72.8115H39.1221Z",
    fill: "#5960AC"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.2621 72.8115C35.0319 91.5103 33.0369 109.932 26.8569 132.415H35.1561C44.1857 113.594 50.6575 95.2627 55.0806 72.8115H34.2621Z",
    fill: "#636BC1"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.8325 140.108L26.0563 136.763C26.0984 136.133 26.7108 135.695 27.3403 135.742C29.878 135.931 32.8521 134.975 32.8521 134.975C35.8678 136.956 39.9689 138.063 42.3997 138.586C43.4715 138.816 44.16 139.915 43.8394 140.963H32.8521H26.4429L25.8325 140.108Z",
    fill: "#191847"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54.7407 140.108L54.9645 136.763C55.0066 136.133 55.619 135.695 56.2485 135.742C58.7862 135.931 61.7603 134.975 61.7603 134.975C64.776 136.956 68.8771 138.063 71.3079 138.586C72.3797 138.816 73.0682 139.915 72.7476 140.963H61.7603H55.3511L54.7407 140.108Z",
    fill: "#191847"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M73.3497 73.7661L64.3061 65.5801L61.3024 70.4025L70.7066 75.547C73.0646 78.9936 74.4495 80.4827 74.8613 80.0146C75.2085 79.6198 75.0494 79.1871 74.9028 78.7886C74.7886 78.4782 74.682 78.1884 74.8284 77.9534C75.1626 77.4168 77.0507 77.7241 78.829 78.0868C80.6073 78.4495 80.1958 77.639 79.8178 77.216C78.1371 75.9575 75.9811 74.8075 73.3497 73.7661ZM20.0435 85.6595C20.979 83.8984 24.1649 66.7346 24.1649 66.7346L30.8364 66.7589C30.8364 66.7589 24.6574 85.2668 24.1649 86.3992C23.5252 87.8703 24.6119 90.0077 25.3488 91.457C25.4628 91.6812 25.5684 91.889 25.658 92.0752C24.6355 92.4997 24.1444 91.9866 23.6266 91.4457C23.0417 90.8347 22.4229 90.1882 20.9661 90.817C20.4032 91.06 19.8707 91.3472 19.3503 91.6279C17.553 92.5972 15.9018 93.4878 13.6556 92.2018C13.2995 91.9979 12.9093 91.2303 13.8522 90.6304C16.2011 89.136 19.5861 86.5204 20.0435 85.6595Z",
    fill: "#D4A181"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.1244 40.7595L45.885 40.3201C50.6378 51.3366 58.9358 61.3464 70.7788 70.3496L61.8296 80.4378C49.988 67.6184 42.6887 54.3923 43.1244 40.7595Z",
    fill: "#191847"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.0903 72.9491H55.6725C55.6725 72.9491 47.1298 53.6764 47.1298 40.2053L39.7146 39.1802C33.8869 47.8767 32.2412 58.5838 31.0903 72.9491Z",
    fill: "#DDE3E9"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.9165 82.7243C22.6049 54.5823 39.5515 39.1802 39.5515 39.1802L39.5574 39.185C39.5584 39.1834 39.5594 39.1818 39.5604 39.1802H40.0444C40.9132 39.2079 42.6909 39.2802 42.6909 39.2802L44.4827 44.0313C44.767 52.7204 47.8032 79.053 47.8032 79.053H31.7127C31.7401 80.2603 31.8007 81.4847 31.8981 82.7243H19.9165Z",
    fill: "#34396F"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.7157 79.1696C31.5873 73.9118 32.09 68.9749 32.9286 64.5073C33.3672 69.8087 34.2839 76.1877 36.1985 79.1696H31.7157Z",
    fill: "black",
    fillOpacity: 0.1
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.2759 69.987L43.2217 66.5596V69.987H35.2759Z",
    fill: "white",
    fillOpacity: 0.2
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 79.8506,
    y: 7.81641,
    width: 88.2771,
    height: 115.761,
    rx: 10,
    fill: "#636BC1"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 85.4683,
    y: 13.4004,
    width: 77.4431,
    height: 102.733,
    fill: "white"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 107.537,
    y: 6.32764,
    width: 33.3045,
    height: 9.30551,
    rx: 4.65276,
    fill: "#34396F"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M121.861 0C118.16 0 115.161 2.99968 115.161 6.69997H133.619C133.619 2.99968 130.619 0 126.919 0H121.861ZM119.516 2.60547C119.105 2.60547 118.772 2.93867 118.772 3.34968C118.772 3.7607 119.105 4.0939 119.516 4.0939H128.862C129.273 4.0939 129.606 3.7607 129.606 3.34968C129.606 2.93867 129.273 2.60547 128.862 2.60547H119.516Z",
    fill: "#34396F"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 93.9932,
    y: 37.7217,
    width: 15.0504,
    height: 13.8888,
    rx: 4.5,
    stroke: "#5F67CF"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    y1: -1,
    x2: 5.30443,
    y2: -1,
    transform: "matrix(0.674725 0.738069 -0.741804 0.670616 94.6973 45.8438)",
    stroke: "#636BC1",
    strokeWidth: 2
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    y1: -1,
    x2: 12.6659,
    y2: -1,
    transform: "matrix(0.762893 -0.646525 0.650405 0.759587 98.2759 49.7598)",
    stroke: "#636BC1",
    strokeWidth: 2
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 112.753,
    y: 40.9443,
    width: 42.1322,
    height: 2.23265,
    rx: 1.11632,
    fill: "#D9D9D9"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 112.753,
    y: 46.1553,
    width: 42.1322,
    height: 2.23265,
    rx: 1.11632,
    fill: "#D9D9D9"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 93.9932,
    y: 58.5664,
    width: 15.0504,
    height: 13.8888,
    rx: 4.5,
    stroke: "#5F67CF"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M95.1807 66.3472L98.7597 70.2622",
    stroke: "#636BC1",
    strokeWidth: 2
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    y1: -1,
    x2: 12.6659,
    y2: -1,
    transform: "matrix(0.762893 -0.646525 0.650405 0.759587 98.2759 70.605)",
    stroke: "#636BC1",
    strokeWidth: 2
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 112.753,
    y: 61.7886,
    width: 42.1322,
    height: 2.23265,
    rx: 1.11632,
    fill: "#D9D9D9"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 112.753,
    y: 67,
    width: 42.1322,
    height: 2.23265,
    rx: 1.11632,
    fill: "#D9D9D9"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 93.9932,
    y: 79.4106,
    width: 15.0504,
    height: 13.8888,
    rx: 4.5,
    stroke: "#5F67CF"
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    y1: -1,
    x2: 5.30443,
    y2: -1,
    transform: "matrix(0.674725 0.738069 -0.741804 0.670616 94.6973 87.5332)",
    stroke: "#636BC1",
    strokeWidth: 2
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    y1: -1,
    x2: 12.6659,
    y2: -1,
    transform: "matrix(0.762893 -0.646525 0.650405 0.759587 98.2759 91.4497)",
    stroke: "#636BC1",
    strokeWidth: 2
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 112.753,
    y: 82.6328,
    width: 42.1322,
    height: 2.23265,
    rx: 1.11632,
    fill: "#D9D9D9"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 112.753,
    y: 87.8438,
    width: 42.1322,
    height: 2.23265,
    rx: 1.11632,
    fill: "#D9D9D9"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M100.342 29.3335H99.1885L100.946 24.2426H102.333L104.088 29.3335H102.935L101.659 25.4059H101.62L100.342 29.3335ZM100.27 27.3324H102.994V28.1726H100.27V27.3324ZM103.885 25.13V24.2426H108.066V25.13H106.507V29.3335H105.443V25.13H103.885ZM108.561 25.13V24.2426H112.742V25.13H111.183V29.3335H110.119V25.13H108.561ZM113.43 29.3335V24.2426H116.861V25.13H114.507V26.3431H116.684V27.2305H114.507V28.4461H116.871V29.3335H113.43ZM121.975 24.2426V29.3335H121.045L118.83 26.1293H118.793V29.3335H117.716V24.2426H118.661L120.858 27.4443H120.903V24.2426H121.975ZM124.669 29.3335H122.864V24.2426H124.683C125.196 24.2426 125.636 24.3445 126.006 24.5483C126.375 24.7505 126.66 25.0414 126.859 25.4209C127.059 25.8004 127.159 26.2544 127.159 26.7831C127.159 27.3134 127.059 27.7691 126.859 28.1503C126.66 28.5314 126.374 28.8239 126.001 29.0277C125.63 29.2316 125.186 29.3335 124.669 29.3335ZM123.94 28.4113H124.624C124.942 28.4113 125.21 28.3549 125.427 28.2422C125.645 28.1279 125.81 27.9514 125.919 27.7128C126.03 27.4725 126.085 27.1626 126.085 26.7831C126.085 26.4069 126.03 26.0995 125.919 25.8608C125.81 25.6222 125.646 25.4465 125.429 25.3339C125.212 25.2212 124.944 25.1648 124.626 25.1648H123.94V28.4113ZM128.547 29.3335H127.394L129.151 24.2426H130.538L132.293 29.3335H131.14L129.864 25.4059H129.825L128.547 29.3335ZM128.475 27.3324H131.199V28.1726H128.475V27.3324ZM137.164 24.2426V29.3335H136.234L134.019 26.1293H133.982V29.3335H132.906V24.2426H133.85L136.048 27.4443H136.093V24.2426H137.164ZM142.545 26.0249H141.456C141.436 25.884 141.396 25.7589 141.335 25.6495C141.273 25.5385 141.195 25.4441 141.098 25.3662C141.002 25.2883 140.891 25.2286 140.765 25.1872C140.641 25.1458 140.506 25.125 140.36 25.125C140.097 25.125 139.867 25.1905 139.672 25.3214C139.476 25.4507 139.324 25.6396 139.217 25.8882C139.109 26.1351 139.055 26.4351 139.055 26.788C139.055 27.151 139.109 27.4559 139.217 27.7028C139.326 27.9497 139.479 28.1362 139.674 28.2621C139.87 28.3881 140.096 28.451 140.353 28.451C140.497 28.451 140.63 28.432 140.753 28.3939C140.877 28.3557 140.987 28.3002 141.083 28.2273C141.18 28.1527 141.259 28.0624 141.322 27.9564C141.387 27.8503 141.432 27.7293 141.456 27.5934L142.545 27.5984C142.517 27.8321 142.447 28.0575 142.334 28.2745C142.223 28.49 142.073 28.683 141.884 28.8537C141.697 29.0228 141.473 29.157 141.213 29.2564C140.954 29.3542 140.662 29.4031 140.335 29.4031C139.881 29.4031 139.475 29.3004 139.117 29.0949C138.761 28.8894 138.479 28.5919 138.272 28.2025C138.067 27.813 137.964 27.3415 137.964 26.788C137.964 26.2329 138.068 25.7606 138.277 25.3711C138.486 24.9817 138.769 24.6851 139.127 24.4812C139.485 24.2757 139.888 24.173 140.335 24.173C140.63 24.173 140.904 24.2144 141.156 24.2973C141.409 24.3801 141.634 24.5011 141.829 24.6602C142.025 24.8176 142.184 25.0107 142.307 25.2394C142.431 25.4681 142.51 25.7299 142.545 26.0249ZM143.317 29.3335V24.2426H146.747V25.13H144.393V26.3431H146.571V27.2305H144.393V28.4461H146.757V29.3335H143.317Z",
    fill: "#636BC1"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M100.315 103.105H108.556C111.318 103.105 113.556 105.344 113.556 108.105V133.466C113.556 136.228 111.318 138.466 108.557 138.466H100.315V103.105Z",
    fill: "#E6E6E6"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M75.0356 108.105C75.0356 105.344 77.2742 103.105 80.0356 103.105H108.557C111.318 103.105 113.557 105.344 113.557 108.105V114.644H75.0356V108.105Z",
    fill: "#5158A4"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 73.0293,
    y: 103.105,
    width: 38.5209,
    height: 35.3609,
    rx: 5,
    fill: "white"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M73.0293 108.105C73.0293 105.344 75.2679 103.105 78.0293 103.105H106.55C109.312 103.105 111.55 105.344 111.55 108.105V114.644H73.0293V108.105Z",
    fill: "#636BC1"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 76.2393,
    y: 100.5,
    width: 3.21007,
    height: 6.69997,
    rx: 1.60504,
    fill: "#424242"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 83.8633,
    y: 100.5,
    width: 3.21007,
    height: 6.69997,
    rx: 1.60504,
    fill: "#424242"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 91.0859,
    y: 100.5,
    width: 3.21007,
    height: 6.69997,
    rx: 1.60504,
    fill: "#424242"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 97.5059,
    y: 100.5,
    width: 3.21007,
    height: 6.69997,
    rx: 1.60504,
    fill: "#424242"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 105.13,
    y: 100.5,
    width: 3.21007,
    height: 6.69997,
    rx: 1.60504,
    fill: "#424242"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 86.2705,
    y: 117.622,
    width: 4.81511,
    height: 4.46664,
    fill: "#E6E6E6"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 78.647,
    y: 124.322,
    width: 4.81511,
    height: 4.46664,
    fill: "#E6E6E6"
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 78.647,
    y: 131.021,
    width: 4.81511,
    height: 4.46664,
    fill: "#E6E6E6"
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 86.2705,
    y: 124.322,
    width: 4.81511,
    height: 4.46664,
    fill: "#E6E6E6"
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    x: 86.2705,
    y: 131.021,
    width: 4.81511,
    height: 4.46664,
    fill: "#E6E6E6"
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    x: 93.8945,
    y: 117.622,
    width: 4.81511,
    height: 4.46664,
    fill: "#E6E6E6"
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    x: 93.8945,
    y: 124.322,
    width: 4.81511,
    height: 4.46664,
    fill: "#E6E6E6"
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    x: 101.519,
    y: 124.322,
    width: 4.81511,
    height: 4.46664,
    fill: "#CE4E4E"
  })), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    x: 101.519,
    y: 117.622,
    width: 4.81511,
    height: 4.46664,
    fill: "#CE4E4E"
  })), _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    x: 93.8945,
    y: 131.021,
    width: 4.81511,
    height: 4.46664,
    fill: "#E6E6E6"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_785_2586"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 185.472,
    height: 62.2482,
    fill: "white",
    transform: "matrix(0.988451 -0.151539 0.175401 0.984497 5.75146 113.717)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttendance2);
export default __webpack_public_path__ + "static/media/attendance2.e64172d3ccb96a5423ad566af560466a.svg";
export { ForwardRef as ReactComponent };